
























































































































import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Comments from './components/Comments.vue'
import PdfViewer from '@/components/PdfViewer.vue'
import Confirm from '@/components/Confirm.vue'
import ScrollView from '@/components/ScrollView.vue'
import BatchSuccessModal from './components/BatchSuccessModal.vue'
import ResidentContactsList from './components/ResidentContactsList.vue'
import EditStatementModal from './components/EditStatementModal.vue'
import AddMessageLetter from './components/AddMessageLetter.vue'
import SharedFunctions from './SharedFunctions'
import {
  EBatchType,
  EFacilityBlockableFeatures,
  EFacilityStatementMode,
  EOrigin,
  EStatementStatuses,
  EUserPermissions,
  IFacility,
  IResident,
  isObj,
  isString,
  IStatement
} from '@zunta/configurations'
import StatementsStatusesActions from './components/StatementsStatusesActions.vue'
import ChangeMailContactModal from './components/ChangeMailContactModal.vue'
import moment from 'moment'
import Api from '@/api'
import { User } from '@/classes/User'
import StatusFiltersV2 from './components/StatusFiltersV2.vue'
import { UserModule } from '@/store/modules/user.module'
import { getModule } from 'vuex-module-decorators'
import GoBack from '@/components/GoBack.vue'
import StatusStatement from '@/components/statuses/StatusStatement.vue'
import StatementsMailSuccessModal from '@/views/app/management/mailings/components/StatementsMailSuccessModal.vue'
import ModalV2 from '@/components/modals/ModalV2.vue'
import { isFacilityFeatureBlocked } from '@/utils/facility/facilityFeatures'
import StatementResidentNavigation from './components/StatementResidentPagination.vue'

@Component({
  components: {
    ModalV2,
    StatementsMailSuccessModal,
    StatusStatement,
    GoBack,
    StatusFiltersV2,
    ChangeMailContactModal,
    StatementsStatusesActions,
    AddMessageLetter,
    EditStatementModal,
    ResidentContactsList,
    Icon,
    Comments,
    PdfViewer,
    Confirm,
    ScrollView,
    BatchSuccessModal,
    StatementResidentNavigation
  }
})
export default class ReviewStatements extends SharedFunctions {
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  EFacilityStatementMode: any = EFacilityStatementMode
  EUserPermissions: any = EUserPermissions
  EStatementStatuses: any = EStatementStatuses
  user = Api.getUser() as User

  lineItemEditStatement: boolean = false
  isMailing: boolean = false
  showMailSuccessModal: boolean = false

  get confirmMessage () {
    if (!this.readyToMailStatementsCount) {
      return 'There are no statements to mail out.'
    }
    return `Your batch is ready to go! Are you ready to send ${this.readyToMailStatementsCount} statement(s)?`
  }

  get confirmContent () {
    if (!this.readyToMailStatementsCount) {
      return ''
    }
    return `
      <p><b>${this.mailStatements.mailed}</b> statements will be mailed.</p>
      <p><b>${this.mailStatements.paperless}</b> statements will be emailed.</p>
      <p><b>${this.mailStatements.deliverToRoom}</b> statements will be delivered to resident’s room by ${this.mailStatementsUser}</p>
     `
  }

  get mailStatementsUser () {
    if (!this.mailStatements.printedStatementUser) {
      return ''
    }
    const user = this.$store.state.statement.mailStatements.printedStatementUser
    return `${user && user.firstName ? user.firstName : ''} ${user && user.lastName ? user.lastName : ''}`
  }

  get confirmSubMessage () {
    if (!this.readyToMailStatementsCount) {
      return ''
    }
    return 'You will not be able to cancel this action.'
  }

  get mailStatements () {
    return this.$store.state.statement.mailStatements
    // const list = this.$store.state.statement.statementList
    // return {
    //   printedStatementUser: '',
    //   mailed: list.filter((statement: IStatement) => (statement.status === EStatementStatuses.READY_TO_MAIL)).length || 0,
    //   paperless: list.filter((statement: IStatement) => (statement.status === EStatementStatuses.READY_TO_EMAIL)).length || 0,
    //   deliverToRoom: list.filter((statement: IStatement) => (statement.status === EStatementStatuses.READY_TO_PRINT)).length || 0
    // }
  }

  get isNcs () {
    if (!this.selectedStatement) {
      return false
    }
    return (this.selectedStatement.facility as any).origin === EOrigin.NCS
  }

  get facilityStatementMode () {
    if (this.selectedBatch && this.selectedBatch.facility && this.selectedBatch.facility.statementMode) {
      return this.selectedBatch.facility.statementMode
    }
    return null
  }

  get selectedStatementFacility (): IFacility | null {
    return this.selectedStatement && isObj(this.selectedStatement.facility) ? this.selectedStatement.facility as IFacility : null
  }

  get fileName () {
    if (!this.selectedStatement) {
      return ''
    }
    const firstName = (this.selectedStatement.resident as IResident).firstName ? (this.selectedStatement.resident as IResident).firstName.replace('/', ' ') as string : ''
    const lastName = (this.selectedStatement.resident as IResident).lastName ? (this.selectedStatement.resident as IResident).lastName.replace('/', ' ') as string : ''
    const createDate = moment(this.selectedBatch.createdAt).utcOffset(this.user.getTimezone() * 60).format('MM_DD_YYYY')
    return `${firstName}_${lastName}_${createDate}`
  }

  toggleEditLineItemModal (val: boolean) {
    this.lineItemEditStatement = val
  }

  async onLineItemsUpdate () {
    // this.$eventBus.$emit('loading:enable', { message: 'Updating' })
    this.toggleEditLineItemModal(false)
    // await this.fetchData()
    await Promise.all([
      this.batchModuleInstance.fetchBatch(this.batchID),
      this.fetchList(),
      this.updateStatistics(),
      this.commentModuleInstance.fetchStatementComments((this.selectedStatement as IStatement).id),
      this.statementModuleInstance.fetchStatementMessages({
        statementId: ((this.selectedStatement as IStatement).resident as IResident).id,
        batchId: this.batchID
      }),
      this.fetchContactsList(),
      this.getRelatedResidents()
    ])
    setTimeout(() => {
      // this.$eventBus.$emit('loading:disable')
      this.$eventBus.$emit('comments:update')
    }, 400)
  }

  closeSuccessModal () {
    this.statementModuleInstance.setSuccessModalState(false)
    this.goBack()
  }

  closeConfirmMail () {
    this.statementModuleInstance.setConfirmMailModalState(false)
    this.goBack()
  }

  async mail () {
    this.isMailing = true
    this.statementModuleInstance.setConfirmMailModalState(false)
    const response: any = this.batchType === EBatchType.LETTERS
        ? await this.statementModuleInstance.sendLettersBatchMails(parseInt(this.batchID))
        : await this.statementModuleInstance.sendStatementsBatchMails(parseInt(this.batchID))

    if (response !== 'Fail') {
      // this.$eventBus.$emit('notify', {
      //   color: 'var(--status-success-color)',
      //   message: 'Process Started',
      //   header: `Send Batch ${this.batchType === EBatchType.LETTERS ? 'Statements' : 'Letters'} Via Mail`,
      //   icon: 'check'
      // })
    } else {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Process Failed',
        header: `Send Batch ${this.batchType === EBatchType.LETTERS ? 'Statements' : 'Letters'} Via Mail`,
        icon: 'warning'
      })
    }
    this.isMailing = false
    await this.statementModuleInstance.getBatchStatementListByFilters({
      batchId: this.batchID,
      filters: {
        mailed: 'unmailed'
      }
    })
    await this.statementModuleInstance.fetchMailStatements(this.batchID)
    // this.statementModuleInstance.setSuccessModalState(true)
    this.showMailSuccessModal = true
    await this.updateStatistics()
    this.statementModuleInstance.updateStatementFilterType('ALL')
  }

  async revertLineItemsStatementChanges (forAll: boolean = false) {
    if (this.selectedStatement && this.selectedStatement.id) {
      this.$eventBus.$emit('loading:enable', { message: 'Generate Statement' })
      this.toggleEditLineItemModal(false)
      const response = await this.statementModuleInstance.revertStatement({ statementId: this.selectedStatement.id, forAll })
      if (!isString(response)) {
        if (response && response.message) {
          this.$eventBus.$emit('notify', {
            color: 'var(--status-error-color)',
            message: Array.isArray(response.message) ? response.message.join('\n') : response.message,
            header: `Revert Statement`,
            icon: 'warning'
          })
        }
      }
      await this.fetchData()
      setTimeout(() => {
        this.$eventBus.$emit('loading:disable')
        this.$eventBus.$emit('comments:update')
      }, 400)
    }
  }

  goToResident (options: any) {
   this.$locationManager.openNewTab(this.$router.resolve(options).href)
  }

  beforeDestroy () {
    if (this.selectedStatement && this.previousStatementId !== this.selectedStatement.id) {
      this.commentModuleInstance.resetStatementComments()
    }
    this.statementModuleInstance.resetResidentBatchStatements()
  }

  async mounted () {
    document.body.style.overflowY = 'auto'
    this.$eventBus.$emit('loading:enable', { message: 'Generate Statement' })
    await Promise.all([
      this.userModuleInstance.getManagementUsersList({}),
      this.fetchData(),
      this.fetchTemplates(),
      this.fetchContactsList()
    ])

    if (!this.selectedStatement) {
      const statementsFilteredByType: IStatement[] = this.statementList && this.$route.params.type
          ? this.statementList.filter((s: IStatement) => s.status === this.$route.params.type)
          : []

      if (statementsFilteredByType.length) {
        await this.changeStatement(statementsFilteredByType[0].id)
      } else {
        await this.changeStatement(this.statementList[0].id)
      }
    }

    if (!this.$route.params.type) {
      await this.changeStatement((this.selectedStatement as IStatement).id)
    }

    if ((!this.selectedStatementsList || (this.selectedStatementsList && !this.selectedStatementsList.length)) && this.pageType !== 'mailed') {
      this.changeStatementsType('ALL')
    }

    await this.getRelatedResidents()
  }

  destroyed () {
    document.body.style.overflowY = 'scroll'
    this.statementModuleInstance.SET_STATEMENT_TYPE_FILTER('ALL')
  }

  get isStatementGenAndMailBlocked () {
    return !this.selectedStatementFacility || isFacilityFeatureBlocked(this.selectedStatementFacility, EFacilityBlockableFeatures.MailAndGenStatements)
  }
}
